/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router, RouterLink } from '@angular/router';
import { NB_AUTH_OPTIONS } from '../../auth.options';
import { getDeepFromObject } from '../../helpers';
import { environment } from '../../../../environments/environment';
import { NbAuthService } from '../../services/auth.service';
import { NbAuthResult } from '../../services/auth-result';
import {
  animate, state, style, transition, trigger
} from '@angular/animations';
import { ApiService } from '../../../services/api/api.service';
import { FormsModule } from '@angular/forms';
import { NbAlertModule, NbSpinnerModule, NbInputModule, NbCheckboxModule, NbButtonModule } from '@nebular/theme';
import { NgIf, NgFor } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LogoSvgComponent } from '../../../pages/auth/logoSvg/logo.svg.component';
import { Observable } from 'rxjs';
import { StatusIconDirective } from '../../../directives/status-icon.directive';

@Component({
    selector: 'nb-login',
    templateUrl: './login.component.html',
    /* changeDetection: ChangeDetectionStrategy.OnPush, */
    styleUrls: ['./login.component.scss'],
    animations: [
        trigger('slide', [
            state('login', style({ transform: 'translateX(0)' })),
            state('twoFA', style({ transform: 'translateX(-50%)' })),
            transition('* => *', animate('0.7s cubic-bezier( 0.22, 0.97, 0.45, 0.97 )'))
        ]),
    ],
    standalone: true,
    imports: [LogoSvgComponent, NgIf, NbAlertModule, NgFor, NbSpinnerModule, FormsModule, NbInputModule, RouterLink, NbCheckboxModule, NbButtonModule, TranslateModule, StatusIconDirective]
})

export class NbLoginComponent implements OnInit{

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';
  errors: string[] = [];
  messages: string[] = [];
  user: {email?: string, password?: string, twoFAtoken?: string, clientCode?: string, rememberMe?: string} = {};
  submitted: boolean = false;
  twoFAsubmitted: boolean = false;
  rememberMe = false;
  showElements :  "login" | "twoFA" = "login"
  oneTimeLoginToken: string = null;
  queryParams$ = Observable<string>;
  @Input() activePane: PaneType = 'left';
  environment = environment

  constructor(protected auth: NbAuthService,
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected cd: ChangeDetectorRef,
              protected router: Router,
              private api: ApiService,
              private route: ActivatedRoute,
              public translate: TranslateService) {

    this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
    this.showMessages = this.getConfigValue('forms.login.showMessages');
    
    this.rememberMe = false
  }
  
// tell backend to send you a twoFA token
  async sendTwoFA() {
    this.errors = [];
    this.messages = [];
    this.twoFAsubmitted = true;
    var result;

    try{

        if (environment.childOrMasterOrGateway == 'gateway') {

          result = await this.auth.makeClientSendTwoFA(this.user.email, this.user.password, this.user.clientCode)
        } else {
          result = await this.auth.sendTwoFA(this.strategy, {email: this.user.email! , password: this.user.password!})
        }

          this.twoFAsubmitted = false; // as we just asked for the twoFA
          
          if (result.success && !result.response?.data?.jwt) {
            this.messages = [this.translate.instant('login.twoFASent')];
            this.showElements = "twoFA"
          } else if(result.response?.data.jwt && result.response.data.user) {
          // if the response contains a jwt and user, we can directly log in the user
            await this.processDirectLogin(result);
          }
          else {
            if (result.response?.status.toString().startsWith("4")) {
              this.errors = [this.translate.instant('login.error.wrongCredentials')];
            } else {
              this.errors = [this.translate.instant('login.error.serviceUnreachable')];
            }
            
          }
          
          this.cd.detectChanges();
          
      } catch(e) {
        this.showCorrectError(e);
        this.twoFAsubmitted = false; 
          console.devlog("Fetching 2FA failed:", e)
      }

    };

    showCorrectError(error){
      if(!error.response){
        this.errors = [this.translate.instant('login.error.serviceUnreachable')];
      } else if(error.code == 'ERR_NETWORK'){
        this.errors = [this.translate.instant('login.error.network')];
      } else if(error.response.data?.clientError == 'ECONNREFUSED'){
        this.errors = [this.translate.instant('login.error.connRefused')];
      } else if(error.response.data?.clientError == 'EBADTWOFATOKEN'){
        this.errors = [this.translate.instant('login.error.badTwoFA')];
      } else if(error.response.data.clientError == 'EBADINPUT'){
        this.errors = [this.translate.instant('login.error.badInput')];
      } else if(error.response.data.clientError == 'ECLIENTDATAINCOMPLETE'){
        this.errors = [this.translate.instant('login.error.clientDataIncomplete')];
      } else if(error.response.data.clientError == 'ENOMASTER'){
        this.errors = [this.translate.instant('login.error.noMaster')];
      } else {
        this.errors = [this.translate.instant('login.error.twoFAFailed')];
      }
    }

  loginWithTwoFa(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    try{
      // gateway scenario: don't call the auth method, just the endpoint to get the oneTimeLoginToken and redirect the user.
      if(environment.childOrMasterOrGateway == 'gateway'){
        this.auth.getOneTimeLoginToken(this.user.email, this.user.password, this.user.clientCode, this.user.twoFAtoken).then((result) => {
          
          let finalUrl = `${result.redirectTo}/login?otlt=${result.oneTimeLoginToken}`
          console.devlog("Final redirectionUrl: " + finalUrl)
          window.location.href = finalUrl
          
        }).catch((e) => {
          console.devlog("Error fetching oneTimeLoginToken", e)
          this.showCorrectError(e);
        })
        return
      } else {
        this.auth.authenticate('email', this.api, this.user).subscribe(async (result: NbAuthResult) => {
          this.submitted = false;
          
          // already doing this in runAfterLogin()
          // await this.api.setMe(); 
          
          if (result.isSuccess()) {
            this.messages = result.getMessages();
          } else {
            this.errors = result.getErrors();
          }
          
          // commented this redirect because it is already happening in runAfterLogin()
          // const redirect = result.getRedirect();
          // if (redirect) {
          //   setTimeout(() => {
          //     return this.router.navigateByUrl(redirect);
          //   }, this.redirectDelay);
          // }
          this.cd.detectChanges();
        });

      }
        
    } catch(e) {
        this.showCorrectError(e);
        this.submitted = false; 
          console.devlog("Fetching 2FA failed:", e)
      }
    }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  // Gateway scenario: The gateway will redirect you to this login site with a oneTimeLoginToken in the params,
  // we automatically process it and log in the user
  loginWithOneTimeLoginToken(otlt : string){
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    this.auth.authenticate('email', this.api, {oneTimeLoginToken : otlt}).subscribe(async (result: NbAuthResult) => {
      this.submitted = false;
      
      if (result.isSuccess()) {
        await this.api.setMe();
        this.messages = result.getMessages();
      } else {

        // in case the jwt is malformed
        if(result['response'].error.error.details.errors[0].message.startsWith("Could not decode jwt: JsonWebTokenError:")){
          //response.error.error.details.errors[0].message
          this.errors.push(this.translate.instant('login.error.tokenDecodeError', { code: this.oneTimeLoginToken }))
        } else if (result['response'].error.error.details.errors[0].message.startsWith("Could not decode jwt: TokenExpiredError")) {
          
          // in case the jwt is expired
          this.errors.push(this.translate.instant('login.error.tokenExpired'))
        } else {
          this.errors = result.getErrors();
        }
      } 

      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
      this.cd.detectChanges();
    });
  }

  ngOnInit(): void {

    // check if there was a oneTimeLoginToken provided
    //debugger
     let params : Params = this.route.snapshot.queryParams;

    if(params.otlt){
      this.oneTimeLoginToken = params.otlt
      this.loginWithOneTimeLoginToken(this.oneTimeLoginToken)
    } 
  }

  async processDirectLogin(authResult) {
    console.devlog("Processing direct login with authResult:", authResult);
  try {
    const responseData = authResult.response.data;

    if (environment.childOrMasterOrGateway == 'gateway') {
      // Gateway scenario
      let finalUrl = `${responseData.redirectTo || window.location.origin}/dashboard?otlt=${responseData.jwt}`;
      console.devlog("Final redirectionUrl: " + finalUrl);
      window.location.href = finalUrl;
    } else {
      // Regular scenario - use your existing authenticate method
      this.auth.authenticate('email', this.api, this.user).subscribe(async (result: NbAuthResult) => {
        this.submitted = false;

        if (result.isSuccess()) {
          await this.api.setMe({overridePublicRoutesCheck: true});
          this.messages = [this.translate.instant('login.success')];

          // disabling this redirect for now: it causes issues in HHplatform, and in medpoc the user is automatically redirected though other means - investigate.
          /* const redirect = result.getRedirect() || '/dashboard';
          setTimeout(() => {
            return this.router.navigateByUrl(redirect);
          }, this.redirectDelay); */
        } else {
          this.errors = result.getErrors();
        }

        this.cd.detectChanges();
      });
    }
  } catch (e) {
    this.showCorrectError(e);
    console.devlog("Error processing direct login:", e);
  }
}

}

type PaneType = 'left' | 'right';

